module.exports = __webpack_public_path__ + "img/20200912_130842.35f3032b.jpg";